import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField,
} from '@mui/material';
import { useWorkspace } from './WorkspaceContext.js';
import { ACTION_META } from './workspaceConstants.js';

// Opened by clicking a Maßnahme on the map. Retention basins, ditches and
// embankments have a single depth/height; infiltration areas have their own
// three rates.
const ActionPropertiesDialog = () => {
  const { selectedAction, updateSelectedActionValues, closeActionDialog, saveSelectedAction } = useWorkspace();

  const open = Boolean(selectedAction);
  const type = selectedAction ? selectedAction.type : null;
  const values = selectedAction ? selectedAction.values : {};

  return (
    <Dialog open={open} onClose={closeActionDialog} fullWidth maxWidth="xs">
      <DialogTitle>{type ? `${ACTION_META[type].label} Eigenschaften` : ''}</DialogTitle>
      <DialogContent>
        {type === 'infiltration' ? (
          <>
            <TextField
              label="Anfängliche Versickerungsrate [mm/h]"
              type="number"
              margin="dense"
              fullWidth
              value={values.infiltration_rate_start ?? ''}
              onChange={(e) => updateSelectedActionValues({ infiltration_rate_start: e.target.value })}
            />
            <TextField
              label="Endgültige Versickerungsrate [mm/h]"
              type="number"
              margin="dense"
              fullWidth
              value={values.infiltration_rate_end ?? ''}
              onChange={(e) => updateSelectedActionValues({ infiltration_rate_end: e.target.value })}
            />
            <TextField
              label="Abklingfaktor [1/h]"
              type="number"
              margin="dense"
              fullWidth
              value={values.decay_factor ?? ''}
              onChange={(e) => updateSelectedActionValues({ decay_factor: e.target.value })}
            />
          </>
        ) : (
          <TextField
            label={type === 'embankment' ? 'Höhe [m]' : 'Tiefe [m]'}
            type="number"
            margin="dense"
            fullWidth
            value={values.depth ?? ''}
            onChange={(e) => updateSelectedActionValues({ depth: e.target.value })}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={closeActionDialog}>Abbrechen</Button>
        <Button variant="contained" onClick={saveSelectedAction}>Speichern</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActionPropertiesDialog;
